(() => {
  $(() => {
    // START Minimize Header
    var targets = $('#page-header, .cc-revoke');
    var previousScrollPosition = window.scrollY;

    function handleHeaderMinimization (currentScrollPosition) {
      if (currentScrollPosition > previousScrollPosition) { // downwards
        targets.toggleClass('minimized', true);
      } else { // upwards
        targets.removeClass('minimized');
      }

      previousScrollPosition = currentScrollPosition;
    }

    var triggerTimeout = null;
    var restraintCount = 0;
    var maxRestraintCount = (window.matchMedia('(hover: none)').matches ? 50 : 20);

    window.addEventListener('scroll', function (event) {
      if (triggerTimeout !== null && restraintCount < maxRestraintCount) {
        clearTimeout(triggerTimeout);
        restraintCount++;
      }

      triggerTimeout = setTimeout(handleHeaderMinimization, 300, [window.scrollY]);
      restraintCount = 0;
    }, Modernizr.passiveeventlisteners ? {passive: true} : false);
    // END Minimize Header
  });
})();